<div class="table-container">
  <!-- <p *ngIf="!price || !summaryDetail">Fetching stock...</p> -->
  <div
    class="content"
    *ngIf="price && summaryDetail"
    [@simpleFadeAnimation]="ready ? 'fadeIn': 'fadeOut'"
  >
    <div class="header-quote">
      <div class="name">
        <h4>{{price.longName}} </h4>
        <h4 [innerHtml]="nameDivider"></h4>
        <h4
          class="symbol"
          (click)="symbolClicked(price.symbol)"
        > {{price.symbol}}</h4>
      </div>
      <button
        mat-button
        color="primary"
        (click)="refreshQuote()"
      >Refresh</button>
    </div>
    <p class="sub-title">{{price.exchangeName}} {{delayedState}} Currency in {{price.currency}}
    </p>
    <div class="price-container">
      <h4 class="price">{{price.regularMarketPrice.fmt}}</h4>
      <h3 [innerHtml]="priceDivider"></h3>
      <h3
        class="price-change-perc"
        [ngStyle]="{'color': getPriceFmt(price).color}"
      > {{price.regularMarketChange.fmt}} ({{price.regularMarketChangePercent.fmt}})</h3>
    </div>


    <p class="sub-title">{{prefixTime}}{{price.asOfTime}} EDT </p>

    <table>
      <tbody>
        <tr>
          <td>Previous Close</td>
          <td>{{summaryDetail.previousClose.fmt}}</td>
        </tr>
        <tr>
          <td>Open</td>
          <td>{{summaryDetail.open.fmt}}</td>
        </tr>
        <tr>
          <td>Bid</td>
          <td>{{summaryDetail.bid.fmt}} x {{summaryDetail.bidSize.fmt}}</td>
        </tr>
        <tr>
          <td>Ask</td>
          <td>{{summaryDetail.ask.fmt}} x {{summaryDetail.askSize.fmt}}</td>
        </tr>
        <tr>
          <td>Day's Range</td>
          <td>{{summaryDetail.regularMarketDayLow.fmt}} -
            {{summaryDetail.regularMarketDayHigh.fmt}}
          </td>
        </tr>
        <tr>
          <td>52 Week Range</td>
          <td>{{summaryDetail.fiftyTwoWeekLow.fmt}} - {{summaryDetail.fiftyTwoWeekHigh.fmt}}
          </td>
        </tr>
        <tr>
          <td>Volume</td>
          <td>{{summaryDetail.volume.longFmt}}</td>
        </tr>
        <tr>
          <td>Avg. Volume</td>
          <td>{{summaryDetail.averageVolume.longFmt}}</td>
        </tr>
        <tr>
          <td>Market Cap</td>
          <td>{{summaryDetail.marketCap.fmt}}</td>
        </tr>
        <tr>
          <td>Beta (5Y Monthly)</td>
          <td>{{summaryDetail.beta.fmt}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
